import { render, staticRenderFns } from "./FieldType12.vue?vue&type=template&id=86d62dfa&scoped=true"
import script from "./FieldType12.vue?vue&type=script&lang=js"
export * from "./FieldType12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d62dfa",
  null
  
)

export default component.exports